import { fontSize } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';

const { text, spacing, fonts } = dggTheme;

export const tile = css`
  margin: 0 ${pxToRem(spacing.sm)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: 300px;
      margin-bottom: ${pxToRem(spacing.xxxxl)};
    `,
  )}

  img {
    object-fit: cover;
    border-radius: ${pxToRem(30)};
    width: 100px;
    height: 100px;

    ${mediaQuery(
      { min: breakpoint },
      css`
        border-radius: ${pxToRem(80)};
        width: 300px;
        height: 300px;
      `,
    )}
  }

  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }
`;

export const title = css`
  margin: 10px 0;
  text-align: center;
  ${fontSize(text.BODY.SM)}
  line-height: normal;
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  padding-bottom: ${pxToRem(spacing.sm)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(text.HEADING.MD.fontSize)};
      margin: 20px 0;
    `,
  )}
`;
